/**
 * Vanity equipment ids for `POST /api/data/items/batch`.
 * Source: dotv `equipment_data.json` (vanity + character-display equip slots).
 */
export const CREATOR_EQUIPMENT_ITEM_IDS: string[] = [
  // bassinian-warder
  "e.bassinian-warder-breeches",
  "e.bassinian-warder-coat",
  "e.bassinian-warder-gloves",
  "e.bassinian-warder-hat",
  "e.bassinian-warder-shoes",
  // blessed-gastonia
  "e.blessed-gastonia-boots",
  "e.blessed-gastonia-clubbed-whip",
  "e.blessed-gastonia-gloves",
  "e.blessed-gastonia-helm",
  "e.blessed-gastonia-pants",
  "e.blessed-gastonia-shield",
  "e.blessed-gastonia-spikes",
  // bolting-fiddler
  "e.bolting-fiddler-blade",
  "e.bolting-fiddler-boots",
  "e.bolting-fiddler-carapace",
  "e.bolting-fiddler-claws",
  "e.bolting-fiddler-helm",
  "e.bolting-fiddler-pants",
  "e.bolting-fiddler-shield",
  // caligae
  "e.gipantan-caligae",
  "e.thiadoran-sandals",
  "e.vozotls-treads",
  // chandler
  "e.chandlers-chausses",
  "e.chandlers-chestplate",
  "e.chandlers-gauntlets",
  "e.chandlers-guard",
  "e.chandlers-helm",
  "e.chandlers-rod",
  "e.chandlers-sabatons",
  // colossal-crusherclaw
  "e.colossal-crusherclaw-boots",
  "e.colossal-crusherclaw-carapace",
  "e.colossal-crusherclaw-claws",
  "e.colossal-crusherclaw-helm",
  "e.colossal-crusherclaw-pants",
  "e.colossal-crusherclaw-tower-shield",
  "e.colossal-crusherclaw-warhammer",
  // conqueror
  "e.conquerors-cuisses",
  "e.conquerors-lamellar-cuirass",
  "e.conquerors-sabatons",
  "e.conquerors-sallet",
  "e.conquerors-vambraces",
  "e.jida-of-sovereign-hope",
  "e.saber-of-bloody-freedom",
  // cumberworld
  "e.cumberworld-gloves",
  "e.cumberworld-mask",
  "e.cumberworld-overalls",
  "e.cumberworld-paddle",
  "e.cumberworld-poppers",
  "e.cumberworld-shoes",
  "e.cumberworld-tunic",
  // demonsbane
  "e.demonsbanes-armor",
  "e.demonsbanes-gauntlets",
  "e.demonsbanes-helm",
  "e.demonsbanes-legs",
  "e.demonsbanes-sabatons",
  // fanghunter
  "e.fanghunters-boots",
  "e.fanghunters-coverings",
  "e.fanghunters-cowl",
  "e.fanghunters-gloves",
  "e.fanghunters-leather-pants",
  "e.fanghunters-quarreller",
  "e.fanghunters-stake-sender",
  // granite-blesser
  "e.granite-blessers-boots",
  "e.granite-blessers-chestplate",
  "e.granite-blessers-cuisses",
  "e.granite-blessers-gauntlets",
  "e.granite-blessers-guard",
  "e.granite-blessers-rod",
  "e.granite-blessers-visor",
  // legacy
  "e.blade-of-mestari",
  "e.legacy-greatshield",
  "e.mestari-dragonslayer-blue",
  "e.mestari-dragonslayer-green",
  "e.mestari-dragonslayer-indigo",
  "e.mestari-dragonslayer-orange",
  "e.mestari-dragonslayer-red",
  "e.mestari-dragonslayer-violet",
  "e.mestari-dragonslayer-yellow",
  // longeares
  "e.helm-of-longeares",
  // meftet
  "e.meftets-blade",
  "e.meftets-cap",
  "e.meftets-claws",
  "e.meftets-leather",
  "e.meftets-pants",
  "e.meftets-plumbatae",
  "e.meftets-shoes",
  // mephitic-chiffon
  "e.mephitic-chiffon-buckler-shield",
  "e.mephitic-chiffon-cap",
  "e.mephitic-chiffon-fur",
  "e.mephitic-chiffon-gloves",
  "e.mephitic-chiffon-hooves",
  "e.mephitic-chiffon-pants",
  "e.mephitic-chiffon-staff",
  // miray
  "e.mirays-aegis",
  "e.mirays-bascinet",
  "e.mirays-embrace",
  "e.mirays-gauntlets",
  "e.mirays-greaves",
  "e.mirays-lance",
  "e.mirays-legplates",
  // mordant-moswa
  "e.mordant-moswa-antlers",
  "e.mordant-moswa-fur",
  "e.mordant-moswa-gloves",
  "e.mordant-moswa-hooves",
  "e.mordant-moswa-pants",
  "e.mordant-moswas-orb",
  "e.mordant-moswas-wand",
  // naitour-patrol
  "e.naitour-patrol-blade",
  "e.naitour-patrol-cuisses",
  "e.naitour-patrol-gauntlets",
  "e.naitour-patrol-helm",
  "e.naitour-patrol-mail",
  "e.naitour-patrol-sabatons",
  "e.naitour-patrol-shield",
  // plain-farmer
  "e.plain-cloth-pants",
  "e.plain-farmers-tunic",
  "e.training-sword",
  // red-dragonhunter
  "e.red-dragonhunters-armor",
  "e.red-dragonhunters-boots",
  "e.red-dragonhunters-gloves",
  "e.red-dragonhunters-helm",
  "e.red-dragonhunters-lance",
  "e.red-dragonhunters-pants",
  "e.red-dragonhunters-shield",
  // scolfield
  "e.scolfields-bergere",
  "e.scolfields-bodice",
  "e.scolfields-gloves",
  "e.scolfields-heels",
  "e.scolfields-lash",
  "e.scolfields-skirts",
  "e.scolfields-wand",
  // sinderklaz
  "e.sinderklaz-bol",
  "e.sinderklaz-boots",
  "e.sinderklaz-coat",
  "e.sinderklaz-gloves",
  "e.sinderklaz-hat",
  "e.sinderklaz-pants",
  "e.sinderklaz-shield",
  "e.sinderklaz-spihlgode",
  "e.sinderklaz-zurstok",
  // skliros
  "e.skliros-cleaver",
  "e.skliros-inflicter",
  "e.skliros-punisher",
  // spiderskin
  "e.spiderskin-cap",
  "e.spiderskin-chest",
  "e.spiderskin-feet",
  "e.spiderskin-gloves",
  "e.spiderskin-pants",
  // stormshapers
  "e.stormshapers-armor",
  "e.stormshapers-boots",
  "e.stormshapers-bracers",
  "e.stormshapers-carver",
  "e.stormshapers-charge",
  "e.stormshapers-cuisses",
  "e.stormshapers-focus",
  "e.stormshapers-guide",
  "e.stormshapers-helm",
  "e.stormshapers-point",
  "e.stormshapers-spark",
  // sung-leather
  "e.sung-leather-boots",
  "e.sung-leather-gloves",
  "e.sung-leather-helm",
  "e.sung-leather-pants",
  "e.sung-leather-vest",
  "e.sung-wooden-boomerang",
  "e.sungreed-bullwhip",
  // thunderbird
  "e.thunderbirds-feather",
  "e.thunderbirds-gloves",
  "e.thunderbirds-hide",
  "e.thunderbirds-moccasins",
  "e.thunderbirds-pants",
  "e.thunderbirds-rod",
  "e.thunderbirds-swordbreaker",
  // veiled-griphornis
  "e.veiled-griphornis-beak",
  "e.veiled-griphornis-darts",
  "e.veiled-griphornis-feathers",
  "e.veiled-griphornis-pants",
  "e.veiled-griphornis-sickles",
  "e.veiled-griphornis-talons",
  "e.veiled-griphornis-wings",
  // zaratan
  "e.zaratans-gauntlets",
  "e.zaratans-guard",
  "e.zaratans-helm",
  "e.zaratans-legplates",
  "e.zaratans-mace",
  "e.zaratans-sabatons",
  "e.zaratans-shell",
] as const;

export const CREATOR_EQUIPMENT_ITEM_ID_COUNT = 187;